import "@arco-design/web-react/es/Empty/style";
import _Empty from "@arco-design/web-react/es/Empty";
import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import _IconRefresh from "@arco-design/web-react/icon/react-icon/IconRefresh";
import _IconDelete from "@arco-design/web-react/icon/react-icon/IconDelete";
import _IconEdit from "@arco-design/web-react/icon/react-icon/IconEdit";
import _IconPlus from "@arco-design/web-react/icon/react-icon/IconPlus";
import _IconEmail from "@arco-design/web-react/icon/react-icon/IconEmail";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import _IconLoading from "@arco-design/web-react/icon/react-icon/IconLoading";
import _IconTag from "@arco-design/web-react/icon/react-icon/IconTag";
import _IconInteraction from "@arco-design/web-react/icon/react-icon/IconInteraction";
import _IconExperiment from "@arco-design/web-react/icon/react-icon/IconExperiment";
import _IconPoweroff from "@arco-design/web-react/icon/react-icon/IconPoweroff";
import _IconMoonFill from "@arco-design/web-react/icon/react-icon/IconMoonFill";
import _IconSunFill from "@arco-design/web-react/icon/react-icon/IconSunFill";
import _IconNotification from "@arco-design/web-react/icon/react-icon/IconNotification";
import _IconLanguage from "@arco-design/web-react/icon/react-icon/IconLanguage";
import _IconMenuUnfold from "@arco-design/web-react/icon/react-icon/IconMenuUnfold";
import _IconMenuFold from "@arco-design/web-react/icon/react-icon/IconMenuFold";
import _IconMenu from "@arco-design/web-react/icon/react-icon/IconMenu";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import _IconExclamationCircle from "@arco-design/web-react/icon/react-icon/IconExclamationCircle";
import _IconCheckCircle from "@arco-design/web-react/icon/react-icon/IconCheckCircle";
import _IconApps from "@arco-design/web-react/icon/react-icon/IconApps";
import _IconFile from "@arco-design/web-react/icon/react-icon/IconFile";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import _IconList from "@arco-design/web-react/icon/react-icon/IconList";
import _IconDashboard from "@arco-design/web-react/icon/react-icon/IconDashboard";
import React, { useState } from 'react';
// 定义项目中使用的图标映射
const iconMap = {
  dashboard: _IconDashboard,
  list: _IconList,
  settings: _IconSettings,
  file: _IconFile,
  apps: _IconApps,
  check_circle: _IconCheckCircle,
  exclamation_circle: _IconExclamationCircle,
  user: _IconUser,
  menu: _IconMenu,
  menu_fold: _IconMenuFold,
  menu_unfold: _IconMenuUnfold,
  language: _IconLanguage,
  notification: _IconNotification,
  sun_fill: _IconSunFill,
  moon_fill: _IconMoonFill,
  poweroff: _IconPoweroff,
  experiment: _IconExperiment,
  interaction: _IconInteraction,
  tag: _IconTag,
  loading: _IconLoading,
  lock: _IconLock,
  email: _IconEmail,
  plus: _IconPlus,
  edit: _IconEdit,
  delete: _IconDelete,
  refresh: _IconRefresh
};

// 图标选项列表
const iconOptions = Object.keys(iconMap).map(key => ({
  label: key,
  value: key
}));
const IconPicker = ({
  value,
  onChange,
  placeholder
}) => {
  const [searchValue, setSearchValue] = useState('');

  // 根据搜索值过滤图标选项
  const filteredOptions = iconOptions.filter(option => option.label.toLowerCase().includes(searchValue.toLowerCase()));

  // 渲染图标
  const renderIcon = iconName => {
    const IconComponent = iconMap[iconName];
    return IconComponent ? /*#__PURE__*/React.createElement(IconComponent, null) : null;
  };
  return /*#__PURE__*/React.createElement(_Select, {
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    showSearch: true,
    onSearch: setSearchValue,
    allowClear: true,
    dropdownRender: menu => /*#__PURE__*/React.createElement("div", null, menu)
  }, filteredOptions.map(option => /*#__PURE__*/React.createElement(_Select.Option, {
    key: option.value,
    value: option.value
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      marginRight: 8
    }
  }, renderIcon(option.value)), /*#__PURE__*/React.createElement("span", null, option.label)))), filteredOptions.length === 0 && /*#__PURE__*/React.createElement(_Empty, null));
};
export default IconPicker;